import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import Menu from "@menu/components/menu";
import Spinner from "@menu/components/shared/spinner";
import { maxMobileWidth } from "@menu/core/constants";
import useEffectOnce from "@menu/core/hooks/use-effect-once";
import { inboxCache } from "@menu/core/inbox";
import getSiteAndCulture from "@menu/core/lib/get-site-and-culture";
import MenuContext, { initializeMenuEvents, MenuContextOptions } from "@menu/core/menu.context";
import getCountryAndCulture from "@menu/core/lib/get-country-and-culture";
import { ConfigService, SettingsService } from "@menu/core/services";
import { NavItem } from "@menu/core/types";
import { sessionManager } from "core/instances";
import getSiteMenu from "core/models/site-menu";
import { appSettings } from "core/config";
import InboxStoreManager from "core/stores/inbox.store.manager";

declare global {
    interface String { toLowerUnderscoreCase(): string; }
}

require("@menu/core/lib/lower-underscore-case");

type MenuAppProps = {
    location: any
}

const MenuApp = observer((props: MenuAppProps) => {
    const [context, setContext] = useState<MenuContext | undefined>(undefined);

    const { location } = props;

    const initialize = async () => {
        console.log("Initialize Menu");

        const site = "business";
        const { culture } = getSiteAndCulture();

        const service = new ConfigService();
        const countriesTask = service.getCountries(site);
        const configTask = new ConfigService().getConfig(culture, site);
        const mainSiteTask = service.getConfig("", "");

        const countries = await countriesTask;
        const config = await configTask;

        if (!config) {
            console.warn("Menu config is null");
            return;
        }

        const mainConfig = await mainSiteTask;

        const isLoggedIn = await sessionManager.hasAccessAsync();

        // if (isLoggedIn) {
        config.sites[0].navItems = getSiteMenu() as NavItem[];
        // }

        const { country, countryCulture } = getCountryAndCulture(countries, culture);

        const menuContextOptions: MenuContextOptions = {
            config,
            siteName: site,
            countries,
            country,
            culture: countryCulture
        };

        const menuContext = new MenuContext(menuContextOptions);

        const isInboxEnabled = appSettings.isEnabled.inbox;

        if (isInboxEnabled) {
            const data = InboxStoreManager.GetMenuData(0);
            menuContext.updateInbox(data);
        }

        const settings = await new SettingsService().getSettings(menuContext.countryCode, window.location.pathname);

        menuContext.updateSettings(settings);

        if (!!mainConfig) {
            menuContext.updateMainSettings(mainConfig);
        }

        menuContext.updateIsLoggedIn(isLoggedIn);

        if (isInboxEnabled && inboxCache.isCached) {
            menuContext.updateInbox(inboxCache.value);
        }

        const setIsMobile = () => {
            const isMobile = window.innerWidth <= maxMobileWidth;

            if (!menuContext.isMobile && isMobile) {
                menuContext.updateDisplayMobileNav(false);
            }

            menuContext.updateIsMobile(isMobile);
        }

        setIsMobile();

        setContext(menuContext);

        initializeMenuEvents(menuContext);

        window.addEventListener("resize", setIsMobile);
    }

    useEffectOnce(() => {
        //setTimeout(() => load(), 1000); //use to simulate getting data from web service
        const load = async () => {
            initialize();
        }

        load();
    });

    useEffect(() => {
        context?.updateLocation(location);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return !context
        ? <Spinner />
        : <Menu context={context} />;
});

export default MenuApp;
